const breadcrumbContainer = () => document.querySelector("ol.breadcrumb-list")
export const breadcrumbRoot = () => document.querySelector("#breadcrumb-container")

export function replaceBreadcrumb(html: string) {
    const container = breadcrumbContainer()
    if (container) {
        container.innerHTML = html
    }
}
